export default __webpack_public_path__ + "static/media/misc-books4-480w.e66ffe8a.png";